import { Dialog, DialogContent, DialogHeader, DialogClose } from "@calcom/ui";

type GiactAlertDialogProps = {
  open: boolean;
  handler: React.Dispatch<React.SetStateAction<boolean>>;
};

const GiactAlertDialog = ({ open, handler }: GiactAlertDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={handler}>
      <DialogContent size="xl" enableOverflow>
        <DialogHeader title="Adverse Action Notice" subtitle="Learn more about this declined transaction" />

        <div className="space-y-6">
          <div className="rounded-r-lg border-l-4 border-blue-400 bg-blue-50 p-4">
            <h3 className="mb-2 text-lg font-semibold text-blue-900">Check the following:</h3>
            <ul className="list-inside list-disc space-y-2 text-blue-800">
              <li>Check if you have entered the correct bank account and routing details.</li>
              <li>Check if your bank account is in good standing.</li>
            </ul>
          </div>

          <div className="space-y-4 leading-relaxed text-gray-700">
            <p>
              If the details are correct and are in good standing, This notice is intended to comply with the
              requirements of the federal Fair Credit Reporting (FCRA). We are unable to process your request
              because we were unable to verify or authenticate your account information.
            </p>

            <p>
              Our decision was based in whole, or in part, on information obtained from a consumer reporting
              agency, <strong>GIACT Systems, LLC</strong>. However, GIACT Systems, LLC played no part in the
              decision process and is unable to supply specific reasons for the denial of services.
            </p>

            <div className="rounded-lg bg-gray-50 p-4">
              <h4 className="mb-3 font-semibold text-gray-900">Under the FCRA, you have the right to:</h4>
              <ul className="list-inside list-disc space-y-2 text-gray-700">
                <li>Know the information contained within your report</li>
                <li>
                  Make a written request, no later than 60 days after you receive this notice, for disclosure
                  of this information
                </li>
                <li>
                  Request a free consumer report from GIACT Systems, LLC no later than 60 days following the
                  receipt of this notice
                </li>
                <li>
                  Dispute information contained in the report if you believe that it is inaccurate or
                  incomplete
                </li>
              </ul>
            </div>

            <div className="rounded-lg bg-gray-50 p-4">
              <h4 className="mb-3 font-semibold text-gray-900">GIACT Systems, LLC Contact Information:</h4>
              <div className="text-gray-700">
                <p>
                  <strong>GIACT Systems, LLC</strong>
                </p>
                <p>700 Central Expy S. Suite 300</p>
                <p>Allen, TX 75013</p>
                <p className="mt-2">
                  <a href="tel:1-833-802-8092" className="text-blue-600 underline hover:text-blue-800">
                    1 (833) 802-8092
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end pt-4">
          <DialogClose>
            <button className="rounded-md bg-blue-600 px-6 py-2 text-white transition-colors hover:bg-blue-700">
              Close
            </button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GiactAlertDialog;
